exports.components = {
  "component---src-pages-github-signin-complete-tsx": () => import("./../../../src/pages/github_signin_complete.tsx" /* webpackChunkName: "component---src-pages-github-signin-complete-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-signin-tsx": () => import("./../../../src/pages/signin.tsx" /* webpackChunkName: "component---src-pages-signin-tsx" */),
  "component---src-pages-status-tsx": () => import("./../../../src/pages/status.tsx" /* webpackChunkName: "component---src-pages-status-tsx" */),
  "component---src-pages-upload-tsx": () => import("./../../../src/pages/upload.tsx" /* webpackChunkName: "component---src-pages-upload-tsx" */)
}

